import type { DialogContextProps } from 'src/context/DialogContext'
import type { FormRow } from 'src/generated-types/form-field'
import Form from 'src/screens/customer/form/Form'
import { parseFormSchemaLayoutForPreview } from 'src/screens/customer/form/formSchemaPreviewDialog.action'

export { parseFormSchemaLayoutForPreview } from 'src/screens/customer/form/formSchemaPreviewDialog.action'

export type OpenFormSchemaLayoutPreviewShowDialog = DialogContextProps['showDialog']

export interface OpenFormSchemaLayoutPreviewParams {
  /** Raw JSON string of the layout rows; missing or invalid values result in a no-op. */
  layout: string | undefined
  /** Optional dialog title (e.g. schema name). */
  title?: string
}

/**
 * Opens the same read-only form layout preview dialog as the customer admin FormSchemas table
 * (RemoveRedEye).
 *
 * @returns `true` if the dialog was opened; `false` if `layout` was missing, invalid JSON, or did
 *   not deserialize to a non-empty `FormRow[]` — in that case nothing is shown (callers may use
 *   this to hide preview affordances).
 */
export function openFormSchemaLayoutPreview(
  showDialog: OpenFormSchemaLayoutPreviewShowDialog,
  params: OpenFormSchemaLayoutPreviewParams,
): boolean {
  const layouts: FormRow[] | null = parseFormSchemaLayoutForPreview(params.layout)
  if (!layouts) {
    return false
  }

  showDialog(
    Form,
    {
      componentProps: {
        disabled: true,
        previewMode: true,
        form: undefined,
        onDrop: () => {},
        addLayout: () => {},
        deleteLayout: () => {},
        selectFormField: () => {},
        layouts,
        title: params.title,
        onRearrange: undefined,
        pop: () => {},
        cancelEnabled: true,
      },
      opts: {
        maxWidth: 'md',
        fullWidth: true,
      },
      isAutoCloseDisabled: true,
    },
    undefined,
    true,
  )

  return true
}
